import { render, staticRenderFns } from "./SingpassAgent.vue?vue&type=template&id=cc9a056e&"
import script from "./SingpassAgent.vue?vue&type=script&lang=js&"
export * from "./SingpassAgent.vue?vue&type=script&lang=js&"
import style0 from "./SingpassAgent.vue?vue&type=style&index=0&id=cc9a056e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports